import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './theme';
import companyReducer from './companySlice';
import groupReducer from './groupSlice';
import currentIssueListReducer from './currentIssueList';
import tokenReadyReducer from './tokenReady';
import comchatLabLoadingReducer from './comchatLabLoadingSlice';

export const store = configureStore({
    reducer: {
        theme: themeReducer,
        company: companyReducer,
        group: groupReducer,
        currentIssueList: currentIssueListReducer,
        tokenReady: tokenReadyReducer,
        comchatLabLoading: comchatLabLoadingReducer,
    },
});
